import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrushFlattenIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 20c2 0 4-14 8-14s6 14 8 14",
			opacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 2.5,
			d: "M4 11h16"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 20c2 0 4-9 4-9h8s2 9 4 9",
			opacity: .5
		})
	]
});
export default SvgBrushFlattenIcon;
